import { apiGet, apiGetPDF, apiPostJson } from './api-utils';
import { IResult } from '../models/result-models';
import {
    IServiceOptions,
    IServicePartNumberOptions,
    IServiceRequestInitial,
} from '../models/service-request';

const serviceOptionsURL = '/services/parts/serviceoptions';
const colorExchangeURL =
    '/services/parts/exchange/shippingoptionsboxnumber/default/category/default/boxnumber';
const serviceRequestInstructionsURL = '/pdfs/Service_Request_Instructions.pdf';
const submitServiceRequestURL = '/services/forms/repairReturnNew/';
export const newOrderUrl = '/my-account/online-forms/service-request';
export const reviewRecentOrdersUrl = '/prosite/my-account/order-history';

export const getServiceOptions = async (): Promise<
    IResult<IServiceOptions>
> => {
    const result = await apiGet<IServiceOptions>(serviceOptionsURL);

    return result;
};

export const getShippingOptions = async (): Promise<
    IResult<IServiceOptions>
> => {
    const result = await apiGet<IServiceOptions>(colorExchangeURL);

    return result;
};

export const getServiceRequestInstructions = async (): Promise<Response> => {
    const result = await apiGetPDF(serviceRequestInstructionsURL);

    return result;
};

export const getPartNumberOptions = async (
    partNumber: string
): Promise<IResult<IServicePartNumberOptions>> => {
    const result = await apiGet<IServicePartNumberOptions>(
        `/services/parts/${partNumber}/options`
    );

    return result;
};

export const submitServiceRequest = async (
    dto: IServiceRequestInitial
): Promise<Response> => {
    const body = JSON.stringify(dto);
    const result = await apiPostJson(submitServiceRequestURL, body);
    return result;
};
